var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPincheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3643_10575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 16.0547L25.875 29.5547L19.125 22.8047",
    stroke: "#121212",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8125 22.8045C47.8117 18.9731 46.724 15.2205 44.6756 11.9826C42.6273 8.74465 39.7024 6.1543 36.2406 4.51235C32.7788 2.8704 28.9223 2.24424 25.1189 2.70659C21.3154 3.16894 17.7212 4.70082 14.7537 7.12433C11.7861 9.54784 9.56699 12.7635 8.35404 16.3979C7.14109 20.0322 6.98409 23.9361 7.90127 27.6561C8.81845 31.3762 10.7722 34.7597 13.5355 37.4136C16.2989 40.0676 19.7585 41.8832 23.5125 42.6495L27.5625 53.1795L31.6125 42.6495C36.1864 41.7158 40.2973 39.2305 43.2494 35.6142C46.2015 31.9979 47.8135 27.4727 47.8125 22.8045V22.8045Z",
    stroke: "#121212",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3643_10575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(0 0.867188)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPincheck);
export default __webpack_public_path__ + "static/media/pincheck.66c391413db748de7931ebe84ff4603d.svg";
export { ForwardRef as ReactComponent };